export default "{\n    \"toolTips\": {\n        \"suggestUpgrade\": \"Actualice su plan para acceder a esta función\"\n    }\n}\n"